"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgSendBroadcastRawUserMessageCtl = /** @class */ (function (_super) {
    __extends(DlgSendBroadcastRawUserMessageCtl, _super);
    function DlgSendBroadcastRawUserMessageCtl() {
        return _super.call(this, true) || this;
    }
    DlgSendBroadcastRawUserMessageCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            messageTitle: "",
            dialogTitle: "",
            messageText: "",
            visible: false,
            brandId: 0,
            brandTitle: "",
            brandsAvail: [],
            languageId: 0,
            languageTitle: "",
            languagesAvail: [],
            onNo: null
        };
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.SetOnYesClick = function (callback, forceUpdate) {
        this.DATA.onYes = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.GetOnYesClick = function () {
        return this.DATA.onYes;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.SetDialogTitle = function (title, forceUpdate) {
        this.DATA.dialogTitle = title;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.GetDialogTitle = function () {
        return this.DATA.dialogTitle;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.SetMessageTitle = function (title, forceUpdate) {
        this.DATA.messageTitle = title;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.GetMessageTitle = function () {
        return this.DATA.messageTitle;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.SetMessageText = function (body, forceUpdate) {
        this.DATA.messageText = body;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.GetMessageText = function () {
        return this.DATA.messageText;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.SetBrands = function (brands, forceUpdate) {
        this.DATA.brandsAvail = brands;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.GetBrands = function () {
        return this.DATA.brandsAvail;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.SetBrandId = function (brandId, forceUpdate) {
        this.DATA.brandId = brandId;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.GetBrandId = function () {
        return this.DATA.brandId;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.SetBrandTitle = function (brandTitle, forceUpdate) {
        this.DATA.brandTitle = brandTitle;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.GetBrandTitle = function () {
        return this.DATA.brandTitle;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.SetLanguages = function (languages, forceUpdate) {
        this.DATA.languagesAvail = languages;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.GetLanguages = function () {
        return this.DATA.languagesAvail;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.SetLanguageId = function (languageId, forceUpdate) {
        this.DATA.languageId = languageId;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.GetLanguageId = function () {
        return this.DATA.languageId;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.SetLanguageTitle = function (languageTitle, forceUpdate) {
        this.DATA.languageTitle = languageTitle;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawUserMessageCtl.prototype.GetLanguageTitle = function () {
        return this.DATA.languageTitle;
    };
    return DlgSendBroadcastRawUserMessageCtl;
}(BaseController_1.BaseController));
exports.DlgSendBroadcastRawUserMessageCtl = DlgSendBroadcastRawUserMessageCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgSendBroadcastRawUserMessageCtl.ts
// module id = 903
// module chunks = 0